import { render } from "./PeriodData.vue?vue&type=template&id=3a9c3d18&scoped=true"
import script from "./PeriodData.vue?vue&type=script&lang=js"
export * from "./PeriodData.vue?vue&type=script&lang=js"

import "./PeriodData.vue?vue&type=style&index=0&id=3a9c3d18&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9c3d18"]])

export default __exports__